import { render, staticRenderFns } from "./ms-history-pre.vue?vue&type=template&id=3e72aba1&scoped=true"
import script from "./ms-history-pre.vue?vue&type=script&lang=js"
export * from "./ms-history-pre.vue?vue&type=script&lang=js"
import style1 from "./ms-history-pre.vue?vue&type=style&index=1&id=3e72aba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e72aba1",
  null
  
)

export default component.exports